var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _vm.pages
      ? _c(
          "div",
          { staticClass: "category-row" },
          _vm._l(_vm.filteredPages, function(page, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "category-image",
                on: {
                  mouseenter: _vm.floatElement,
                  mouseleave: _vm.unfloatElement
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "ar",
                    style: {
                      "padding-top": (_vm.arHeight / _vm.arWidth) * 100 + "%"
                    }
                  },
                  [
                    _c("div", { staticClass: "zoom-wrapper" }, [
                      _c(
                        "a",
                        {
                          staticClass:
                            "w-100 h-100 d-inline-block position-absolute",
                          attrs: {
                            href: _vm.route("nl.category", { slug: page.slug })
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "image-wrapper w-100 h-100" },
                            [
                              _c("div", {
                                style: {
                                  "background-image":
                                    "url(" +
                                    (page.acf != [] &&
                                    page.acf.meta &&
                                    page.acf.meta.image
                                      ? page.acf.meta.image.sizes.large
                                      : "") +
                                    "), linear-gradient(225deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%)"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "content", style: _vm.contentStyle },
                            [
                              _c("h3", { staticClass: "text-white title" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(page.name) +
                                    "\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "link-arrow link-white" },
                                [
                                  _vm._v(
                                    "Bekijk alle\n                                "
                                  ),
                                  _c("span", {
                                    staticClass: "arrow-right",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.svg("arrow-right"))
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ]
                )
              ]
            )
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.landingpages
      ? _c(
          "div",
          { staticClass: "landing-row" },
          _vm._l(_vm.landingpages, function(page, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "category-image",
                on: {
                  mouseenter: _vm.floatElement,
                  mouseleave: _vm.unfloatElement
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "ar",
                    style: {
                      "padding-top": (_vm.arHeight / _vm.arWidth) * 100 + "%"
                    }
                  },
                  [
                    _c("div", { staticClass: "zoom-wrapper" }, [
                      _c(
                        "a",
                        {
                          staticClass:
                            "w-100 h-100 d-inline-block position-absolute",
                          attrs: { href: "/nl/" + page.post_name }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "image-wrapper w-100 h-100" },
                            [
                              _c("div", {
                                style: {
                                  "background-image":
                                    "url(" +
                                    (page.acf != [] && page.acf.image
                                      ? page.acf.image.sizes.large
                                      : "") +
                                    "), linear-gradient(225deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%)"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "content", style: _vm.contentStyle },
                            [
                              _c("h3", { staticClass: "text-white title" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      page.title != null
                                        ? page.title.rendered
                                        : page.post_title
                                    ) +
                                    "\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "link-arrow link-white" },
                                [
                                  _vm._v(
                                    "Bekijk alle\n                                "
                                  ),
                                  _c("span", {
                                    staticClass: "arrow-right",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.svg("arrow-right"))
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ]
                )
              ]
            )
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.stories
      ? _c(
          "div",
          { staticClass: "stories-row" },
          _vm._l(_vm.stories, function(page, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "category-image",
                on: {
                  mouseenter: _vm.floatElement,
                  mouseleave: _vm.unfloatElement
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "ar",
                    style: {
                      "padding-top": (_vm.arHeight / _vm.arWidth) * 100 + "%"
                    }
                  },
                  [
                    _c("div", { staticClass: "zoom-wrapper" }, [
                      _c(
                        "a",
                        {
                          staticClass:
                            "w-100 h-100 d-inline-block position-absolute",
                          attrs: { href: "/nl/stories/" + page.post_name }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "image-wrapper w-100 h-100" },
                            [
                              _c("div", {
                                style: {
                                  "background-image":
                                    "url(" +
                                    (page.acf != [] && page.acf.image
                                      ? page.acf.image.sizes.large
                                      : "") +
                                    "), linear-gradient(225deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%)"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "content", style: _vm.contentStyle },
                            [
                              _c("h3", { staticClass: "text-white title" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      page.title != null
                                        ? page.title.rendered
                                        : page.post_title
                                    ) +
                                    "\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "link-arrow link-white" },
                                [
                                  _vm._v(
                                    "Bekijk alle\n                                "
                                  ),
                                  _c("span", {
                                    staticClass: "arrow-right",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.svg("arrow-right"))
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ]
                )
              ]
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }